module.exports = __webpack_public_path__ + "media/images/home/bg-white-building-f46072046c7cbc5fd58b9ba4b3067c26.jpg";